import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].GET_IDENTITY_MOUNTS]: {
		url: '/company/:companyId/identity_cards/:identityId/mounts/',
	},
	[ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].GET_IDENTITY_MOUNT]: {
		url: '/company/:companyId/identity_cards/:identityId/mounts/:identityMountId/',
	},
	[ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].CREATE_IDENTITY_MOUNT]: {
		url: '/company/:companyId/identity_cards/:cardId/mounts/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].PATCH_IDENTITY_MOUNT]: {
		url: '/company/:companyId/identity_cards/:identityId/mounts/:mountId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].DELETE_IDENTITY_MOUNT]: {
		url: '/company/:companyId/identity_cards/:identityId/mounts/:mountId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}
